import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStore = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M2.535.626A1.132 1.132 0 0 1 3.547 0h16.906c.428 0 .82.242 1.012.626l2.405 4.81a1.13 1.13 0 0 1 .13.55V7.17a4.755 4.755 0 0 1-2.415 4.14v10.426h1.283a1.132 1.132 0 1 1 0 2.264H1.132a1.132 1.132 0 1 1 0-2.264h1.283V11.309A4.754 4.754 0 0 1 0 7.17V5.948c.003-.184.05-.358.13-.511L2.535.626Zm16.71 11.299.075-.001v9.812h-2.566v-3.698a3.547 3.547 0 0 0-3.547-3.547h-2.415a3.547 3.547 0 0 0-3.547 3.547v3.698H4.68v-9.812h.076a4.755 4.755 0 0 0 3.622-1.675 4.755 4.755 0 0 0 7.245 0 4.755 4.755 0 0 0 3.623 1.675Zm-9.736 9.81h4.981v-3.697a1.283 1.283 0 0 0-1.283-1.283h-2.415a1.283 1.283 0 0 0-1.283 1.283v3.698ZM2.964 4.83l1.283-2.566h15.506l1.283 2.566H2.964Zm4.281 2.264h-4.98v.076a2.49 2.49 0 1 0 4.98 0v-.076Zm2.264.076v-.076h4.981v.076a2.49 2.49 0 0 1-4.98 0Zm7.245 0a2.49 2.49 0 1 0 4.982 0v-.076h-4.982v.076Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStore);
export default ForwardRef;
